<template>
  <v-app>
    <current></current>
  </v-app>
</template>

<script>
import Current from '@/components/ATK_180_v1/Home.vue';

export default {
  name: 'App',

  components: { Current },

  data: () => ({
    //
  }),
};
</script>
